import { render, staticRenderFns } from "./ProgramContentDialog.vue?vue&type=template&id=e064d63a"
import script from "./ProgramContentDialog.vue?vue&type=script&lang=js"
export * from "./ProgramContentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports